import { createAuth0 } from '@auth0/auth0-vue'

/**
 * Auth0 client configuration.
 *
 * Credentials are read from environment variables:
 *   VITE_AUTH0_DOMAIN   – Auth0 tenant domain
 *   VITE_AUTH0_CLIENT_ID – Auth0 SPA client ID
 *   VITE_SUPABASE_URL   – Supabase project URL (used as Auth0 API audience)
 */
const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string | undefined
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined

if (!AUTH0_DOMAIN || !AUTH0_CLIENT_ID) {
  throw new Error(
    '[auth0Client] Missing VITE_AUTH0_DOMAIN or VITE_AUTH0_CLIENT_ID environment variables',
  )
}

export const auth0 = createAuth0({
  domain: AUTH0_DOMAIN,
  clientId: AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin,
    // Include offline_access so Auth0 can issue refresh tokens for smoother silent renewal.
    scope: 'openid profile email offline_access read:data write:data',
    audience: SUPABASE_URL || undefined,
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
  // Fallback for environments where silent auth iframe/cookies are constrained.
  useRefreshTokensFallback: true,
})

export default auth0
